import React from "react";

const C5MapPin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    viewBox="0 0 17.75 26.24"
  >
    <path
      d="M8.88.5C4.25.5.5 4.25.5 8.88c0 4.77 4.89 12.08 8.38 16.55 3.53-4.51 8.38-11.73 8.38-16.55C17.25 4.25 13.5.5 8.88.5zm0 11.1c-1.51 0-2.73-1.22-2.73-2.73s1.22-2.73 2.73-2.73 2.73 1.22 2.73 2.73-1.23 2.73-2.73 2.73z"
      fill="none"
      stroke=""
      strokeMiterlimit="10"
    />
  </svg>
);

export default C5MapPin;
